<i18n>
{
  "fr": {
    "title": "Information générale",
    "close": "Fermer"
  },
  "de": {

  }
}
</i18n>

<template>
  <md-dialog :md-active="show" v-on:md-clicked-outside="onClose" class="about-dialog">
    <md-dialog-title>{{ $t('title') }}</md-dialog-title>

    <md-dialog-content>
      <p>STRATES-VS Viewer est un guichet de consultation cartographique des données Eaux souterraines développé par le <a href="http://www.crealp.ch/" target="_blank">CREALP</a> sous la direction du <a href="https://www.vs.ch/web/sen" target="_blank">Service cantonal de l’environnement (DMTE-SEN), Section protection des eaux</a>.</p>
      <p>Cet outil s’intègre à la future plateforme cantonale STRATES-VS qui vise à terme à assister les praticiens ainsi que les autorités cantonales et locales (gestionnaires, décideurs, etc.) dans leurs tâches de gestion, de protection ou encore d’exploitation des eaux souterraines en leur offrant :</p>
      <ul>
        <li>Un <b>accès centralisé</b> aux informations sur les <b>Eaux souterraines</b> et le <b>Sous-sol</b> (mesures quantitatives et qualitatives, données de forages, sources et puits AEP, réseaux et stations de mesure, etc.)</li>
        <li>Des <b>outils d’aide à la décision</b> (e.g. cartes, indicateurs, etc.) permettant d’avoir un suivi de l’état des ressources pour répondre et/ou évaluer les politiques de gestion des eaux souterraines et d’aménagement du territoire</li>
      </ul>
      <p><i>N.B. : Pour des raisons techniques, il n'est pas possible de garantir l'exactitude, l'exhaustivité et la fiabilité des données. <b>Toutes les données servies à l’utilisateur sont par conséquent dépourvues de foi publique</b>. Celle-ci reste attachée aux seuls documents déposés auprès des institutions maîtresses.</i></p>
      <p><i>Les demandes relatives aux données et aux outils mis à disposition sont à adressées au SEN, par mail à l’adresse <a href="mailto:sen-strates@admin.vs.ch">sen-strates@admin.vs.ch</a>.</i></p>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="onClose()">{{ $t('close') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>

export default {
  name: 'AboutPopup',
  props: {
    show: {
      type: Boolean,
      default: () => { return false }
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
</style>
